<template>
    <div>
        <push-write-link v-for="writeLayout in writeLayouts" :key="`pushComp${writeLayout}`"
                         :writeLayout="writeLayout" :pushData="pushData"></push-write-link>
    </div>
</template>

<script>

import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import pushValidator from "@/mixins/validators/pushValidator";
import pushUtil from "@/components/push/pushUtil";
import PushWriteLink from "@/components/push/PushWriteLink";


export default {
    name: "PushWriteComponent",
    mixins: [alertMixins, pushUtil, pushValidator],
    components: {PushWriteLink},
    inject: ['changeLoading'],
    provide() {
        return {
            pushWriteSetData: this.setData,
        }
    },
    props: {
        pushType: {},
        pushKey: {default: 0},
    },
    data() {
        return {
            writeLayouts: [],
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            getFunc: '',
            detailApiParamsSet: {},
            pushData: {},
            r_idx: '',
            isRunning: false,
            writeOptionalParams: []
        }
    },
    created() {
        this.initFilterConfig();
        if (this.pushKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getPush();
        }
    },
    mounted() {
        EventBus.$on('writePush', this.writePush);
        EventBus.$on('updatePush', this.updatePush);
    },
    beforeDestroy() {
        EventBus.$off('writePush');
        EventBus.$off('updatePush');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        parentChange(data) {
            this.setData(data.key, data.value);
        },
        initTemplateConfig() {
            let configPush = this.returnPushConfig(this.pushType);
            this.writeLayouts = configPush.writeLayouts;
        },
        initFilterConfig() {
            let configPush = this.returnPushConfig(this.pushType);
            this.writeFunc = configPush.writeFunc;
            this.writeApiParamSet = configPush.writeApiParamSet;
            this.parsingData = configPush.parsingData;
            this.getFunc = configPush.getFunc;
            this.detailApiParamsSet = configPush.detailApiParamsSet;
            this.directUrl = configPush.directUrl;
            this.directType = configPush.directType;
            this.keyName = configPush.keyName;
            this.writeSuccessType = configPush.writeSuccessType;
            this.writeFailTypes = configPush.writeFailTypes;
            this.writeOptionalParams = configPush.writeOptionalParams;

        },

        writePush() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let dataArr = Object.keys(this.parsingData);
            dataArr.push("hasCase")
            dataArr.push("isAfterCurrentTime")
            this.$validate(dataArr).then(success => {
                if (!success) {
                    this.isRunning = false;
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, dataArr);
                    });
                    this.errorAlert('필수정보를 모두 입력해주세요.');
                    return;
                }
                this.changeLoading(true);
                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
                dataArr = Object.keys(this.parsingData);
                dataArr.forEach(dataKey => {
                    if (params['as_reservation'] == 0) {
                        delete params['as_reservation_date']
                    }
                    if (Array.isArray(this[dataKey])) {
                        //빈배열제거
                        if (this[dataKey].length > 0) {
                            params[this.parsingData[dataKey]] = this[dataKey];
                        }
                    } else {
                        //값이 배열이 아님
                        if (dataKey === 'gender') {
                            if (this[dataKey] !== null) {
                                params[this.parsingData[dataKey]] = this[dataKey];
                            } else {
                                delete params[this.parsingData[dataKey]]
                            }
                        } else {
                            params[this.parsingData[dataKey]] = this[dataKey];
                        }
                    }
                })
                if (params['as_type'] === 1) {
                    this.writeOptionalParams.forEach(optionalParam => {
                        delete params[optionalParam]
                    })
                }
                if (params['as_type'] == 2) {
                    // this.adjustTimeByOffset();
                    if (this.adjustTimeByOffset().getHours() >= 21 || this.adjustTimeByOffset().getHours() < 8) {
                        this.createConfirm({
                            content: '오후 9시부터 다음날 오전 8시 동안 야간 광고 푸시의 해당 시간이며 광고 푸시 발송이 제한될 수 있습니다.',
                            confirm: () => {
                                return this.runWrite(params);
                            }
                        })
                    } else {
                        return this.runWrite(params);
                    }
                }
                this.runWrite(params);
                this.isRunning = false;
                this.changeLoading(false);
            })
        },
        runWrite(params) {
            try {
                this.$api.$push[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnPushType(res.Info.type);
                    if (type != true) {
                        this.changeLoading(false);
                        this.errorAlert(type);
                        this.isRunning = false;
                        return false;
                    } else {
                        if (this.pushType == 'pushSchedulerDetail') {
                            this.afterFunc(res.Info);
                        } else {
                            this.afterFunc(res.List[this.keyName]);
                        }
                    }
                });
            } catch (e) {
                this.changeLoading(false);
                console.log(e);
            }
        },
        updatePush() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let dataArr = Object.keys(this.parsingData);
            this.$validate(dataArr).then(success => {
                if (!success) {
                    this.isRunning = false;
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, dataArr);
                    });
                    this.errorAlert('필수정보를 모두 입력해주세요.');
                    return;
                }
                this.changeLoading(true);
                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
                dataArr = Object.keys(this.parsingData);
                params['ast_idx'] = this.pushKey;
                params['ast_title'] = this.titleScheduler;
                params['ast_message'] = this.contentScheduler;
                this.runWrite(params);
                this.isRunning = false;
                this.changeLoading(false);
            })
        },
        returnPushType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
            }
        },
        afterFunc(key) {
            this.changeLoading(false);
            let detailKey = key;
            this.createAlert({
                title: '',
                content: '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        this.getPush();
                        return false;
                    }
                    let url = this.directUrl;
                    if (this.directType === 'detail') {
                        url = url + detailKey;
                    }
                    this.$router.push(url);
                }
            })
        },
        adjustTimeByOffset() {
            let inputTime = new Date(this.reservationDate);
            let offsetSign = this.offTime[0]; // 부호 추출 (+ 또는 -)
            let offsetHours = parseInt(this.offTime.slice(1), 10); // 부호를 제외한 숫자 부분을 추출하여 시간 단위로 변환
            if (offsetSign === '+') {
                if (offsetHours !== 0) {
                    inputTime.setHours(inputTime.getHours() + (offsetHours - 9));
                } else {
                    // GMT 오프셋이 +00:00이면 9시간 전으로 조정
                    inputTime.setHours(inputTime.getHours() - 9);
                }
            } else if (offsetSign === '-') {
                inputTime.setHours(inputTime.getHours() - (offsetHours + 9));
            } else {
                console.log('올바르지 않은 GMT 오프셋입니다.');
            }
            this.parentChange('localTime', inputTime);
            return inputTime;
        },
        getPush() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            params[this.keyName] = this.pushKey
            this.$api.$push[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 && res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.pushData = res.List[0];
                if (!util.isEmpty(this.pushData)) {
                    this.pushKey = this.pushData.ast_idx;
                    this.titleScheduler = this.pushData.ast_title;
                    this.contentScheduler = this.pushData.ast_message;
                }
                this.initTemplateConfig();
                this.showLayout = true
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
